import 'aos/dist/aos.css'
import { useEffect } from 'react'
import Footer from './components/Footer'
import Header from './components/Header'
import Hero from './components/Hero'
import Logo from './components/Logo'
import Preloader from './components/Preloader'
import { strangewaysCaHeading, strangewaysCaSubheading, strangewaysDevHeading, strangewaysDevSubheading } from './data/hero'
export default function App() {
  useEffect(() => {
    try {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
      const hasAosElements = !!document.querySelector('[data-aos]')
      if (!prefersReducedMotion && hasAosElements) {
        import('aos')
          .then((mod) => {
            const AOS = mod.default
            AOS.init({
              duration: 500,
              easing: 'ease-in-out',
              delay: 50,
              once: true,
            })
          })
          .catch(() => {
            /* noop */
          })
      }
    } catch {
      /* empty */
    }
  }, [])

  return (
    <div id="app" className="flex min-h-screen flex-col bg-linear-to-br from-brand-50 via-white to-brand-100 dark:from-neutral-950 dark:via-neutral-900 dark:to-brand-950">
      <Preloader />
      <Header />
      <main className="flex-1">
                <Logo />
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
            <Hero heading={strangewaysCaHeading} subheading={strangewaysCaSubheading} href="https://www.strangeways.ca" />
            <Hero heading={strangewaysDevHeading} subheading={strangewaysDevSubheading} href="https://www.strangeways.dev" />
          </div>
        </div>

      </main>
      <Footer />
    </div>
  )
}
